// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
// log
import { fetchData } from "../data/dataActions";
import binaryinterface from "../config/abi.json";
import contract from "../config/config.json";

import WalletConnectProvider from "@walletconnect/web3-provider";

var contractAddress;
var netID;

if (contract.NETWORK.ID == 1){
  contractAddress = String(contract.CONTRACT_ADDRESS);
  netID = 1;
}
if (contract.NETWORK.ID == 5){
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  netID = 11155111;
} 

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connectWalletConnect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());

    const CONFIG = contract
    const abi = binaryinterface

    if (window.ethereum) {
      const provider = new WalletConnectProvider({
        infuraId: "400761e1acf8495b9f87bf7425186f7e",
        rpcUrl: `https://mainnet.infura.io/v3/400761e1acf8495b9f87bf7425186f7e`,
        bridge: "https://bridge.walletconnect.org",
        qrcode: true,
      });

      await provider.enable();
      Web3EthContract.setProvider(provider);
      const web3 = new Web3(provider);
      try {
        const accounts = await web3.eth.getAccounts();
        const networkId = await web3.eth.net.getId();

        if (networkId == netID) {
          const SmartContractObj = new Web3EthContract(
            abi,
            contractAddress
          );
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              web3: web3,
            })
          );
          // Add listeners start
          provider.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          provider.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        } else {
          dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
        }
      } catch (err) {
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      dispatch(connectFailed("Install a wallet."));
      // window.open("https://explorer.walletconnect.com/", '_blank'); 
      // Owen: I turned this off because it was driving me crazy.
    }
  }
};

export const connectCoinbase = () => {
  return async (dispatch) => {
    dispatch(connectRequest());

    const CONFIG = contract
    const abi = binaryinterface

    if (window.ethereum) {
      let provider = window.ethereum;
      if (window.ethereum.providers?.length) {
        window.ethereum.providers.forEach(async (p) => {
          if (p.isCoinbaseWallet) provider = p;
        });
      }

      Web3EthContract.setProvider(provider);
      let web3 = new Web3(provider);
      try {
        const accounts = await provider.request({
          method: "eth_requestAccounts",
        });
        const networkId = await provider.request({
          method: "net_version",
        });
        if (networkId == netID) {
          const SmartContractObj = new Web3EthContract(
            abi,
            contractAddress
          );
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              web3: web3,
            })
          );
          // Add listeners start
          provider.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          provider.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        } else {
          dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
        }
      } catch (err) {
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      dispatch(connectFailed("Install a wallet."));
      window.open("https://www.coinbase.com/wallet/downloads/", '_blank');
    }
  }
};

export const connectWallet = () => {
  return async (dispatch) => {
    dispatch(connectRequest());

    const CONFIG = contract
    const abi = binaryinterface

    if (window.ethereum) {
      let provider = window.ethereum;
      if (window.ethereum.providers?.length) {
        window.ethereum.providers.forEach(async (p) => {
          if (p.isMetaMask) provider = p;
        });
      }

      Web3EthContract.setProvider(provider);
      let web3 = new Web3(provider);
      try {
        const accounts = await provider.request({
          method: "eth_requestAccounts",
        });
        const networkId = await provider.request({
          method: "net_version",
        });
        if (networkId == netID) {
          const SmartContractObj = new Web3EthContract(
            abi,
            contractAddress
          );
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              web3: web3,
            })
          );
          // Add listeners start
          provider.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          provider.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        } else {
          dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
        }
      } catch (err) {
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      dispatch(connectFailed("Install a wallet."));
      window.open("https://metamask.io/download/", '_blank');
    }
  }
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
    //window.location.reload();
  };
};
